import { BaseError } from "@/domains/errors";
import { Location } from "react-router-dom";

export const appleIdentityParseOAuthResult = ({
  location,
}: {
  location: Location;
}): { state: string; error: string | null } => {
  const urlSearchParams = new URLSearchParams(location.search);
  const error = urlSearchParams.get("error");
  const state = urlSearchParams.get("state");

  if (!state) {
    throw new BaseError({ message: "Unable to parse Apple OAuth state." });
  }

  return { state, error };
};
